import { useEffect, useState } from "react";
import Carousel1 from "../../components/carousel/carousel";
import Category from "../../components/category/category";
import Header from "../../components/header/header";
import "./home.css"
import { handleGetDatas } from "../../requests/productRequests";

function Home() {
    const [loader, setLoader] = useState(true)
    const [data, setData] = useState([])
    useEffect(async () => {
        const res = await handleGetDatas()
        setData(res)
    }, [])
    const handleLoad = () => {
        setLoader(false)
    }
    return (
        <>
            {
                loader &&
                <div className="loader-container">
                    <div className="loader"></div>
                </div>
            }
            <div className="home" onLoad={() => handleLoad()}>
                <div className="home-container">
                    <Header />
                    <Category />
                    <Carousel1 data={data} title={"جدیدترین محصولات"} />
                    <div className="parallax"></div>
                </div>
            </div>
        </>
    )
}
export default Home;